import { render, staticRenderFns } from "./CaptureStepIndicator.vue?vue&type=template&id=3b2f6780&scoped=true&"
import script from "./CaptureStepIndicator.vue?vue&type=script&lang=js&"
export * from "./CaptureStepIndicator.vue?vue&type=script&lang=js&"
import style0 from "./CaptureStepIndicator.vue?vue&type=style&index=0&id=3b2f6780&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f6780",
  null
  
)

export default component.exports